<template>
<!-- This example requires Tailwind CSS v2.0+ -->
<div class="fixed z-10 inset-0 overflow-y-auto" :class="showModal?'':'hidden'" aria-labelledby="modal-title" role="dialog" aria-modal="true">
  <div class="flex items-end justify-center pt-4 px-4 pb-20 text-center sm:block sm:p-0">
    <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" aria-hidden="true"></div>

    <!-- This element is to trick the browser into centering the modal contents. -->
    <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>

    <div class="inline-block align-bottom bg-gray-700 rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle p-1">

    <section class="p-3">
      <div class="flex justify-items-start">
        <h4 class="py-2 text-white text-sm font-bold uppercase mb-3">Delete feature</h4>
      </div>
      <div class="content py-4 text-white">
        <h6>Are you sure you want to delete this waypoint?</h6>
      </div>

      <div class="flex justify-between pt-2">
        <button type="button" @click.prevent="hideModalFn" class="btn btn-black">X Cancel</button>
        <button v-if="!delete_coordinates_form.processing" class="btn btn-gradient" @click="deleteWaypoint">
            <i class="trash mr-1 relative top-0.5"></i>Delete
        </button>
        <button v-else class="btn btn-gradient"><Spinner/></button>
      </div>
    </section>

    </div>
  </div>
</div>
</template>

<script>
import Spinner from '@/UI/Spinner';

export default {
  components:{
    Spinner,
  },
  props: [
    'showModal',
    'hideModalFn',
    'current_language',
    'changeLanguage',
    'delete_coordinates_form'
  ],
  methods:{
    deleteWaypoint(){
        this.delete_coordinates_form.delete(route('coordinate.delete', this.$page.props.tour.data.identifier), {
          preserveScroll: true,
          onSuccess: () => {
            this.delete_coordinates_form.waypoint_id = null;
            this.changeLanguage(this.current_language)
            this.hideModalFn();
          },
          onError: (err) => {
            this.hideModalFn();
          }
        });
    }
  },
}

</script>
